export enum ActionStatus {
  DEFAULT='',
  ALLOWED='Available',
  DENIED='Unavailable'
}
